<template>
  <div class="">
    <div class="form-group">
      <label class="form-label">Titel</label>
      <input type="text" class="input w-full" v-model="trial.title" v-bind:class="{ 'input-error': errors.title }"/>
      <div class="input-error-message" v-if="errors.title">{{ errors.title[0] }}</div>
    </div>
    <div class="flex">
      <div class="form-group mr-4">
        <label class="form-label">Datum</label>
        <date-picker v-model="trial.date" valueType="format" format="DD.MM.YYYY"></date-picker>
        <div class="input-error-message" v-if="errors.date">{{ errors.date[0] }}</div>
      </div>
      <div class="form-group">
        <label class="form-label">Zeit</label>
        <input type="text" placeholder="hh:mm" class="input w-full" v-model="trial.time" v-bind:class="{ 'input-error': errors.time }"/>
        <div class="input-error-message" v-if="errors.time">{{ errors.time[0] }}</div>
      </div>
    </div>
    <div class="form-group">
      <label class="form-label">Gericht</label>
      <input type="text" class="input w-full" v-model="trial.court_name" v-bind:class="{ 'input-error': errors.court_name }"/>
      <div class="input-error-message" v-if="errors.court_name">{{ errors.court_name[0] }}</div>
    </div>
    <div class="form-group">
      <label class="form-label">Unterbevollmächtigter</label>
      <input type="text" class="input w-full" v-model="trial.ubv" v-bind:class="{ 'input-error': errors.ubv }"/>
      <div class="input-error-message" v-if="errors.ubv">{{ errors.ubv[0] }}</div>
    </div>
    <div class="form-group">
      <textarea class="w-full input" v-model="trial.description" rows="6">{{ trial.description }}</textarea>
    </div>
    <div class="flex justify-end my-6">
      <button v-on:click="save" class="btn btn-primary">Speichern</button>
    </div>
  </div>
</template>

<script>
import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/locale/de';
import moment from 'moment';

export default {
  components: {DatePicker},
  props: [
    'actionUrl',
    'method',
    'initialTrial',
  ],
  data() {
    return {
      trial: JSON.parse(JSON.stringify(this.initialTrial)),
      errors: [],
    }
  },
  methods: {
    save: function () {
      this.$http[this.method](this.actionUrl, {trial: this.trial}).then(response => {
        console.log(response)
        Vue.$toast.success('Gerichtstermin wurde gespeichert.')
        this.$emit('updated')
      }, response => {
        console.log(response)
        if (response.status = 422) {
          this.errors = response.body;
        }
      })
    },
  },

  mounted: function () {
    this.trial.date = moment(this.trial.date, "YYYY-MM-DD").format("DD.MM.YYYY");
  }
}
</script>
